import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { FirebaseProvider } from './context/FirebaseContext';
import { ThemeProvider } from './context/ThemeContext';
import LoginModal from './components/LoginModal';
import MainPage from './components/MainPage';
import OptionsPage from './components/OptionsPage';
import './App.css';

function App() {
  useEffect(() => {
    const currentHostname = window.location.hostname;
    const targetDomain = 'linkcoder.databandits.nl';
    
    // Check if we're NOT on localhost and NOT on the target domain
    const isLocalhost = currentHostname === 'localhost' || currentHostname === '127.0.0.1';
    const isTargetDomain = currentHostname === targetDomain;
    
    if (!isLocalhost && !isTargetDomain) {
      // Redirect to the target domain, preserving the path and search params
      const targetUrl = `https://${targetDomain}${window.location.pathname}${window.location.search}${window.location.hash}`;
      window.location.replace(targetUrl);
    }
  }, []);

  return (
    <ThemeProvider>
      <FirebaseProvider>
        <Router>
          <Routes>
            <Route
              path="/"
              element={
                <>
                  <MainPage />
                  <LoginModal />
                </>
              }
            />
            <Route
              path="/options"
              element={
                <>
                  <OptionsPage />
                  <LoginModal />
                </>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
      </FirebaseProvider>
    </ThemeProvider>
  );
}

export default App;
